export default "__VITE_ASSET__CVtp3XoK__"